import { getLocalStorageItem } from "../../../helperFunctions";

/**
 * This is Zendesk chat handler.
 */
class LiveChatHandler {
  constructor(chatbotHandler, messages) {
    this.chatbotHandler = chatbotHandler;
    this.conversationDispatch = chatbotHandler.conversationDispatch;

    this.initialMessages = messages;

    this.zChat = window.zChat;

    this.gaveConsent = getLocalStorageItem("gaveConsent");

    this.initListeners();
    this.joinRoom();

    this.isTypingTimeout = null;
  }

  initListeners() {
    this.zChat.on(
      "connection_update",
      eventData => eventData === "connected" && this.handleRoomJoined()
    );
    this.zChat.on("chat", eventData => this.handleChatEvent(eventData));
  }

  joinRoom() {
    let roomId = this.chatbotHandler.roomId;
    this.zChat.init({
      account_key: process.env.ZENDESK_ACCOUNT_KEY,
      suppress_console_error: process.env.GATSBY_ACTIVE_ENV === "production",
      authentication: {
        jwt_fn: function (callback) {
          fetch(`${process.env.CHATBOT_URL}/getJwt/${roomId}`).then(function (res) {
            res.text().then(function (jwt) {
              callback(jwt);
            });
          });
        }
      }
    });
  }

  handleRoomJoined() {
    if (process.env.GATSBY_ACTIVE_ENV !== "production") {
      console.log("Connected to zendesk");
    }
    this.initialMessages.map(msg =>
      this.zChat.sendChatMsg(`${msg.sender}: ${msg.message.text}`)
    );
    this.zChat.setVisitorInfo({
      phone: this.chatbotHandler.customer.phone || ""
    });
  }

  handleChatEvent(eventData) {
    if (process.env.GATSBY_ACTIVE_ENV !== "production") {
      console.log("eventData", eventData);
    }
    switch (eventData.type) {
      case "typing":
        this.conversationDispatch({
          type: eventData.typing ? "appendTyping" : "removeTyping"
        });
        break;
      case "chat.msg": {
        if (eventData.nick !== "visitor") {
          this.handleChatMessage(eventData.msg);
        }
        break;
      }
      case "chat.memberleave": {
        this.chatbotHandler.disconnectLiveChat();
      }
    }
  }

  handleChatMessage(message) {
    this.conversationDispatch({
      type: "appendMessage",
      message: {
        type: "text",
        sender: "agent",
        text: message
      }
    });
  }

  leaveRoom() {
    this.zChat.endChat();
  }

  sendTyping() {
    this.zChat.sendTyping(true);
    clearTimeout(this.isTypingTimeout);
    this.isTypingTimeout = setTimeout(() => {
      window.zChat.sendTyping(false);
    }, 1500);
  }

  sendMessage(message) {
    this.zChat.sendTyping(false);
    this.zChat.sendChatMsg(message);
  }
}

export default LiveChatHandler;
